<template>
    <v-container fluid>
      <v-row>
        <v-col class="col-12">
          <h1>Admin - Manage Work Types</h1>
          <v-row>
            <v-col class="col-12 col-md-4">
              <v-text-field
                label="Search"
                v-model="searchTerm"
                clearable />
            </v-col>
            <v-col class="col-12 col-md-6">
              <v-btn
                @click="addWorkType = true"
                small
                class="float-right">
                Add Work Type
              </v-btn>
            </v-col>
          </v-row>
          <v-row>
            <v-col class="col-12 col-md-8">
              <v-simple-table
                fixed-header
              >
                <template v-slot:default>
                  <thead>
                    <tr>
                      <th class="text-left">Work Type</th>
                      <th>&nbsp;</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr
                      v-for="(type, fIndex) in filteredWorkTypes"
                      :key="fIndex"
                    >
                      <td>{{ type.name }}</td>
                      <td>
                        <v-btn small @click="archive(fIndex)">
                          Archive
                        </v-btn>
                      </td>
                    </tr>
                  </tbody>
                </template>
              </v-simple-table>
            </v-col>
          </v-row>
        </v-col>
      </v-row>
      <div
        class="modal"
        v-if="addWorkType">
        <v-icon
          class="close"
          @click="addWorkType = false"
        >mdi-close-circle</v-icon>
        <v-form>
          <v-row>
            <v-col>
              <v-text-field
                v-model="newWorkType"
                label="Work Type" />
            </v-col>
            <v-col class="pt-8">
              <v-btn
                @click="saveNewWorkType" small>Save Work Type</v-btn>
            </v-col>
          </v-row>
        </v-form>
      </div>
    </v-container>
  </template>
  
  <script>
  import axios from '../../../axios';
  
  export default {
    name: 'AdminSurfaceTypesIndex',
    computed: {
      token() {
        return this.$store.state.token;
      },
    },
    data() {
      return {
        surfaceTypes: [],
        filteredWorkTypes: [],
        searchTerm: null,
        addWorkType: false,
        newWorkType: null,
      };
    },
    watch: {
      searchTerm() {
        this.filterWorkTypes();
      },
    },
    methods: {
      archive(index) {
        const workType = this.filteredWorkTypes[index];
        axios.get(`/workTypes/archive/${workType.id}.json?token=${this.token}`)
          .then((response) => {
            this.workTypes = response.data.workTypes;
            this.filteredWorkTypes = response.data.workTypes;
          })
          .catch((error) => {
            console.log(error);
          });
      },
      saveNewWorkType() {
        const postData = {};
        postData.workType = this.newWorkType;
        axios.post(`/workTypes/create/.json?token=${this.token}`, postData)
          .then((response) => {
            this.workTypes = response.data.workTypes;
            this.filteredWorkTypes = response.data.workTypes;
            this.addWorkType = false;
            this.newWorkType = null;
          })
          .catch((error) => {
            console.log(error);
          });
      },
      filterWorkTypes() {
        this.filteredWorkTypes = this.workTypes;
        if (this.searchTerm) {
          this.filteredWorkTypes = this.workTypes.filter((type) => type.name.toLowerCase().includes(
            this.searchTerm.toLowerCase(),
          ));
        }
      },
      getWorkTypes() {
        axios.get(`/workTypes/getAll.json?token=${this.token}&term=${this.searchTerm}`)
          .then((response) => {
            this.filteredWorkTypes = response.data;
            this.workTypes = response.data;
          })
          .catch((error) => {
            console.log(error);
          });
      },
    },
    mounted() {
      this.getWorkTypes();
    },
  };
  </script>
  